import axios from 'axios';
const API_VERSION = '0.0.1';
const RawAxios = () => {
    return axios.create({
        headers: {
            'X-API-Version': API_VERSION,
            Accepts: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};
const SecureAxios = async () => {
    const headers = {
        'X-API-Version': API_VERSION,
        Accepts: 'application/json',
        'Content-Type': 'application/json',
    };
    const session = localStorage.getItem('session');
    if (session) {
        headers['Authorization'] = `Bearer ${session}`;
    }
    return axios.create({ headers });
};
export { RawAxios, SecureAxios };
